module.exports = __webpack_public_path__ + "static/media/Poppins-Regular.8b6af8e5.ttf";